import * as React from 'react';
import { TrustpilotReview } from '../../types/blocks/tangible-results';
import { Avatar, Typography } from '@mui/material';
import { Star } from 'lucide-react';

interface ReviewsListProps {
  reviews: TrustpilotReview[];
}

export const ReviewsList: React.FC<ReviewsListProps> = ({ reviews }) => (
  <>
    {reviews.map((review) => (
      <div
        key={review.id}
        className="flex-1 p-6 md:p-12 rounded-3xl bg-paper space-y-4 md:space-y-2 flex flex-col h-[250px] md:h-[320px] text-center"
      >
        <div className="flex justify-center gap-1">
          {[...Array(review.rating)].map((_, i) => (
            <Star key={i} className="size-[18px] fill-[#51B380] stroke-[#51B380]" />
          ))}
          {[...Array(5 - review.rating)].map((_, i) => (
            <Star
              key={i + review.rating}
              className="size-[18px] text-white fill-text-primary stroke-text-primary"
            />
          ))}
        </div>

        <Typography variant="h3" className="text-white" component="h3">
          {review.title}
        </Typography>

        <Typography
          variant="body-500"
          className="leading-6 text-text-secondary text-ellipsis overflow-hidden"
          component="p"
        >
          {review.description}
        </Typography>

        <div className="flex items-center justify-center gap-2">
          <Avatar src={review.user?.avatar?.url} alt="Reviewer avatar" />
          <Typography variant="body-500" component="p">
            {review.user?.displayName}
          </Typography>
        </div>
      </div>
    ))}
  </>
);
